import { Atom, TableProperties, BookOpen, ClipboardCheck, MessageSquare, FlaskConical, Beaker, Sparkles, Flame, ListMusic, GraduationCap, Users, School, AlertCircle, LayoutDashboard, Download } from "lucide-react";

export const links = [
  { to: "/", label: "Home", icon: Atom, end: true, tid: "nav-home", desktop: true, primary: true },
  { to: "/curriculum", label: "Curriculum", icon: GraduationCap, tid: "nav-curriculum", desktop: true, primary: true },
  { to: "/table", label: "Table", icon: TableProperties, tid: "nav-table", desktop: true, primary: true },
  { to: "/topics", label: "Topics", icon: BookOpen, tid: "nav-topics" },
  { to: "/quiz", label: "Quiz", icon: ClipboardCheck, tid: "nav-quiz", desktop: true },
  { to: "/simulator", label: "Sim", icon: Beaker, tid: "nav-simulator" },
  { to: "/molecules", label: "Molecules", icon: Sparkles, tid: "nav-molecules", desktop: true },
  { to: "/tutor", label: "Tutor", icon: MessageSquare, tid: "nav-tutor", desktop: true, primary: true },
  { to: "/balancer", label: "Balancer", icon: FlaskConical, tid: "nav-balancer" },
  { to: "/daily", label: "Daily", icon: Flame, tid: "nav-daily", desktop: true },
  { to: "/playlist", label: "Playlist", icon: ListMusic, tid: "nav-playlist" },
  { to: "/class", label: "Class", icon: MessageSquare, tid: "nav-class", desktop: true },
  { to: "/offline", label: "Offline", icon: Download, tid: "nav-offline" },
];

export const roleLinks = {
  teacher: [
    { to: "/teacher/roster", label: "Roster", icon: Users, tid: "nav-roster" },
    { to: "/teacher", label: "Teacher", icon: School, tid: "nav-teacher" },
  ],
  student: [
    { to: "/mistakes", label: "Mistakes", icon: AlertCircle, tid: "nav-mistakes" },
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, tid: "nav-dashboard" },
  ],
};
